const initialState = {
  isNocPreview: false,
  previewLoading: false,
  createNocLoading: false,
  isCreatingNoc: false,
  dynamicValues: {},
  isSuretyRadio: "no",
  emptyPermitConfirmed: false,
  pdfProgressModalOpen: false,
  inQueueMessage: "",
  inQueueDrawer: false,
  emptyPermitOpen: false,
  items: [],
  dotStates: {},
  completed: {},
  intervalIds: {},
  isFinished: false,
  initializeQueue: true,
  isMoreError: false,
  isFailedError: false,
  waitingList: false,
  cardFlip: false,
  moreResultRow: null,
  editNocLoading: false,
  isEditNoc: false,
  isFailed: false,
};

const nocStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_NOC_STATE":
      return {
        ...state,
        ...action.payload,
      };
    case "UPDATE_DOT_STATE":
      return {
        ...state,
        dotStates: {
          ...state.dotStates,
          [action.payload.item]: action.payload.value,
        },
      };
    case "SET_NOC_INTERVAL_ID":
      return {
        ...state,
        intervalIds: {
          ...state.intervalIds,
          [action.payload.item]: action.payload.intervalId,
        },
      };
    case "CLEAR_NOC_INTERVAL_ID":
      const updatedIntervals = { ...state.intervalIds };
      delete updatedIntervals[action.payload];

      return {
        ...state,
        intervalIds: updatedIntervals,
      };
    case "SET_NOC_PROGRESS_COMPLETED":
      return {
        ...state,
        completed: {
          ...state.completed,
          [action.payload.item]: true,
        },
      };
    case "ADD_NOC_STATE_ITEMS":
      return {
        ...state,
        items: [...state.items, action.payload],
      };
    case "UPDATE_NOC_PROGRESS": {
      const { message, ...rest } = action.payload;

      return {
        ...state,
        ...rest, // dynamic flags like isFinished, isMoreError, etc.
        items: state.items.includes(message)
          ? state.items
          : [...state.items, message],
        completed: {
          ...state.completed,
          [message]: true,
        },
      };
    }
    default:
      return state;
  }
};

export default nocStateReducer;
